
import {
  defineComponent,
  ref,
  reactive,
  onMounted,
  computed,
} from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

export default defineComponent({
  components: {
  },

  setup () {
    const showUploadForm = ref(false)
    const router = useRouter()
    const form_action = ref('save')
    const store = useStore()

    const fields = ref([
      {
        title: 'Item Index',
        dataIndex: 'item_index',
        width: 200,
        fixed: 'left'
      },
      {
        title: 'Winame',
        dataIndex: 'winame',
        width: 200,
        fixed: 'left'
      },
      {
        title: 'Transaction ID',
        dataIndex: 'transaction_id',
        width: 200,
        fixed: 'left'
      },
      {
        title: 'Type of Process',
        dataIndex: 'type_of_process',
        width: 200,
      },
      {
        title: 'Preparer',
        dataIndex: 'preparer',
        width: 200,
      },
      {
        title: 'Invoice Number',
        dataIndex: 'invoice_number',
        width: 200,
      },
      {
        title: 'Payment Method',
        dataIndex: 'payment_method',
        width: 200, 
      },
      {
        title: 'Invoice Date',
        dataIndex: 'invoice_date',
        width: 200,
      },
      {
        title: 'Invoice Received Date',
        dataIndex: 'invoice_received_date',
        width: 200,
      },
      {
        title: 'PV Reference Number',
        dataIndex: 'pv_reference_number',
        width: 200,
      },
      {
        title: 'Supplier Name',
        dataIndex: 'supplier_name',
        width: 200,
      },
      {
        title: 'Supplier ID',
        dataIndex: 'supplier_id',
        width: 270,
      },
      {
        title: 'Payment Status',
        dataIndex: 'payment_status',
        width: 200,
      },
      {
        title: 'Org ID',
        dataIndex: 'org_id',
        width: 200,
      },
      {
        title: 'Org Name',
        dataIndex: 'org_name',
        width: 200,
      },
      {
        title: 'GL Date',
        dataIndex: 'gl_date',
        width: 200,
      },
      {
        title: 'Ponumber',
        dataIndex: 'ponumber',
        width: 200,
      },
      {
        title: 'Buyer Name',
        dataIndex: 'buyer_name',
        width: 200,
      },
      {
        title: 'Buyer Tin',
        dataIndex: 'buyer_tin',
        width: 200,
      },
      {
        title: 'Business Style of Buyer',
        dataIndex: 'business_style_of_buyer',
        width: 200,
      },
      {
        title: 'Business Address of Buyer',
        dataIndex: 'business_address_of_buyer',
        width: 200,
      }
    ])

    const index = (payload = {page: 1}) => {
        store.dispatch('ApText/index', payload)
    }

    const filterRecord = (payload: any) => {
        index(payload)
    }
    
    onMounted(index)

    const items = computed(() => store.getters['ApText/items'])
    const loading = computed(() => store.getters['ApText/status'])


    return {
      items,
      loading,
      fields,
      form_action,
      showUploadForm,
      filterRecord
    }
  },
})
